import Avatar from '../components/avatar';
import Dropdown from '../../../../ui/dropdownMenu/dropdownMenu';
import { IUser } from '../../../../../utils/interfaces/user';
import ProfileItems from './profileItems';
import { useSelector } from 'react-redux';
import { FULL_NAME, USER_NAME } from '../../../../../config';
import React, { useEffect, useState } from 'react';
import '../assets/profile.scss';

const Profile = () => {
    const permissionsToken = useSelector((state: IUser) => {
        return state.permissionsToken;
    });
    const [person, setPerson] = useState({ name: ' ', email: '' });
    useEffect(() => {
        if (permissionsToken) {
            const fullname = sessionStorage.getItem(FULL_NAME);
            const username = sessionStorage.getItem(USER_NAME);
            if (fullname && username) {
                setPerson({
                    name: fullname,
                    email: username,
                });
            }
        }
    }, []);
    const [open, setOpen] = useState<boolean>(false);
    return (
        <div className={'profile'} onClick={() => setOpen(!open)}>
            <Avatar name={person.name} />
            <Dropdown dropdown={open} handlerChange={setOpen}>
                <ProfileItems person={person} />
            </Dropdown>
        </div>
    );
};

export default Profile;
